export default __webpack_public_path__ + "static/slide-06-9ac4d67f670dcc8143e4857f0817d3e3.png";